import { FC } from "react";
import { GoogleTagManagerScript } from "~features/tracking/marketing";

const FIXED_GTM_CONTAINERS = ["GTM-WXVNCRX", "GTM-MSK3NHN"];
export const FlicketGoogleTagManagerScripts: FC = () => {
  return (
    <>
      {FIXED_GTM_CONTAINERS.map((containerId) => (
        <GoogleTagManagerScript key={containerId} containerId={containerId} />
      ))}
    </>
  );
};
